import React from 'react';
import { Modal, Form } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import InvoiceService from 'services/InvoiceService';
import CourseService from 'services/CourseService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';
import DatePicker from 'components/common/DatePicker';

//-------------------------------------------------------------------------------------------------------------------

class MissingBookingModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            missingBooking: {}
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.resolve = resolve;
            this.loginInfo = GlobalStateService.getValue('loginInfo');

            this.setState({
                isOpen: true
            });
            this.load();
        });
    }

    async load() {
        this.setState({
            isLoading: true
        });
        const courses = await CourseService.list();
        this.setState({
            courses: courses,
            isLoading: false
        });
    }
    
    close() {
        this.setState({
            isOpen: false,
            isSubmitted: false
        });
        this.resolve();
    }

    updateField(field, value) {
        const missingBooking = { ...this.state.missingBooking };
        missingBooking[field] = value;
        this.setState({
            missingBooking: missingBooking
        });
    }

    async confirmSubmit() {
        const missingBooking = this.state.missingBooking;
        if (!missingBooking.lmsid) {
            BootboxHelper.alert('Please specify LMS ID');
        } else if (!missingBooking.courseID) {
            BootboxHelper.alert('Please specify course');
        } else if (!missingBooking.endDate) {
            BootboxHelper.alert('Please specify end date');
        } else {
            this.setState({
                isLoading: true
            });
            await InvoiceService.submitMissingBooking(missingBooking);
            this.setState({
                isLoading: false,
                isSubmitted: true
            });
        }
    }

    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="missing-booking-modal">
                {this.renderInner()}
            </Modal>
        );
    }

    renderInner() {
        const {
            isLoading,
            isSubmitted,
            missingBooking,
            courses
        } = this.state;

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader />
                </Modal.Body>
            );
        }

        return (<>

            <Modal.Body>

                {isSubmitted ?

                    <div className="alert alert-success">
                        Thank you for your request.<br/>
                        We aim to respond within 48 hours.
                    </div>

                : <>

                    <div className="alert alert-info">
                        Please only complete this if a class you have conducted is not listed in your invoicing section.
                        <br />
                        <br />
                        Bookings will only appear the day after their scheduled completion date.
                    </div>

                    <Form.Group className="mb-3">
                        <Form.Label>LMS ID</Form.Label>
                        <input
                            type="text"
                            className="form-control"
                            value={missingBooking.lmsid || ''}
                            onChange={e => this.updateField('lmsid', e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Course</Form.Label>
                        <select
                            className="form-control"
                            value={missingBooking.courseID || ''}
                            onChange={e => this.updateField('courseID', e.target.value)}
                        >
                            <option value="">(Please select)</option>
                            {courses.map(c =>
                                <option key={c.id} value={c.id}>{c.name}</option>
                            )}
                        </select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Class end date</Form.Label>
                        <DatePicker
                            locale="en-gb"
                            dateFormat="dd/MM/yyyy"
                            selected={missingBooking.endDate ? new Date(missingBooking.endDate) : null}
                            onChange={date => this.updateField('endDate', date)}
                        />
                    </Form.Group>

                </>}

            </Modal.Body>
            <Modal.Footer>
                {isSubmitted ?
                    <button type="button" className="btn btn-secondary ms-auto" onClick={() => this.close()}>
                        Close
                    </button>
                : <>
                    <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-primary ms-auto" onClick={() => this.confirmSubmit()}>
                        Submit
                    </button>
                </>}

            </Modal.Footer>
        </>);
    }
}

export default MissingBookingModal;